import type { BuilderConfig } from '@zeus-health/types';

export function getDefaultBuilderConfig(builderId: string): BuilderConfig {
  return {
    builderId,
    showRequestRecords: true,
    upsell: true,
    patientOverviewPage: {
      cards: [
        { type: 'conditions' },
        { type: 'risk-gaps' },
        { type: 'referrals' },
        { type: 'medications' },
        { type: 'diagnostics' },
        { type: 'episodesOfCare' },
        { type: 'vitals' },
        { type: 'zusInformation' },
      ],
    },
    riskGaps: {
      lensEnabled: false,
      showConfidenceLevels: true,
      lensIncludeAllPatients: false,
      uiEnabled: false,
      statusOptions: {},
    },
  };
}
